import { Platform } from 'react-native';

/**
 * Canonical spacing + font sizes for the Topicus Events app.
 */
const Dimens = {
	// Font sizes
	fontSize10: 10,
	fontSize11: 11,
	fontSize12: 12,
	fontSize13: 13,
	fontSize14: 14,
	fontSize15: 15,
	fontSize16: 16,
	fontSize17: 17,
	fontSize18: 18,
	fontSize20: 20,
	fontSize22: 22,
	fontSize23: 23,
	fontSize24: 24,

	// Line heights
	lineHeight15: 15,
	lineHeight17: 17,
	lineHeight20: 20,
	lineHeight23: Platform.OS === 'android' ? 26 : 23,

	// Icon sizes (number = value in dp)
	iconSize28: 28,

	// Padding (number = value in dp)
	padding0: 0,
	padding2: 2,
	padding4: 4,
	padding5: 5,
	padding6: 6,
	padding8: 8,
	padding10: 10,
	padding12: 12,
	padding15: 15,
	padding16: 16,
	padding20: 20,
	padding24: 24,
	padding25: 25,
	padding30: 30,
	padding32: 32,
	padding40: 40,
	padding48: 48,

	// Margin
	margin0: 0,
	margin2: 2,
	margin4: 4,
	margin5: 5,
	margin6: 6,
	margin8: 8,
	margin10: 10,
	margin12: 12,
	margin15: 15,
	margin16: 16,
	margin20: 20,
	margin24: 24,
	margin25: 25,
	margin30: 30,
	margin32: 32,
	margin35: 35,
	margin40: 40,
	margin48: 48,

	// Border
	borderWidth1: 1,
	borderWidthHairline: 0.5,
};

export default Dimens;
